// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1t7DN","actions":"GroupTable_actions__jTXhv","deleteModalFooter":"GroupTable_deleteModalFooter__2ZfSV"};